import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchStatisticsReferenceRequest,
  BatchStatisticsReferenceRequestToJSON
} from '@/api/models/batch/BatchStatisticsReferenceRequest'
import {
  BatchStatisticsReferenceSelectItemResult,
  BatchStatisticsReferenceSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsReferenceSelectItemResult'

export class BatchStatisticsReferenceApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsReferenceSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsReferenceSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 帳票作成
   * @param request
   */
  async createReference(
    request: BatchStatisticsReferenceRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/reference`,
      BatchStatisticsReferenceRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
